import { render, staticRenderFns } from "./RegistroAreaAdscripcion.vue?vue&type=template&id=67a946ee"
import script from "./RegistroAreaAdscripcion.vue?vue&type=script&lang=js"
export * from "./RegistroAreaAdscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports